(function(){
if(!window.TWB_S||!window.TWB_M||!window.TWB_P){console.warn('TWB finder: fitment data not loaded');return;}
var prod={},keys=[];
for(var i=0;i<window.TWB_P.length;i++){var p=window.TWB_P[i];var k=p[1]||('p'+i);keys.push(k);
prod[k]={n:p[0],s:p[1],p:p[2],a:!!p[3],ss:!!p[4]};}
var makes={};
for(var mk in window.TWB_M){makes[mk]={};
for(var md in window.TWB_M[mk]){makes[mk][md]=window.TWB_M[mk][md].map(function(r){
return [window.TWB_S[r[0]],window.TWB_Y[r[1]],window.TWB_G[r[2]],
r[3]<0?null:keys[r[3]], r[4]<0?null:keys[r[4]], r[5]<0?null:keys[r[5]],
r[6], r[7]];});}}
window.TWB_FITMENT={makes:makes,prod:prod,conf:window.TWB_CONF||{},labels:window.TWB_LAB||{},
xrows:(window.TWB_X&&window.TWB_X.xrows)||[],xindex:(window.TWB_X&&window.TWB_X.xindex)||{}};
})();
(function(){
if(!window.TWB_FITMENT){return;}
const DATA = window.TWB_FITMENT;
const CONFIG = {
lanes: [
{ key:'instore',  label:'At our shop',      fee:{ hours:0,  after:null },
blurb:'Unit 1 / 66 Pilkington St, Garbutt \u2014 about 15 minutes, no appointment',
feeLabel:'Free fitting', address:false, hoursOnly:true },
{ key:'delivery', label:'Free delivery',    fee:{ hours:0,  after:null },
blurb:'Same day to your door during business hours \u2014 drop-off only, you fit it',
feeLabel:'Free',         address:true,  hoursOnly:true },
{ key:'mobile',   label:'We come to you',   fee:{ hours:40, after:120 },
blurb:'We turn up and fit it \u2014 usually within the hour during business hours',
feeLabel:'From $40',     address:true,  hoursOnly:false }
],
money: v => '$' + Number(v).toFixed(2).replace(/\.00$/,'')
};
/* Coax hand-off. Creates a live-chat enquiry in the Coax inbox against the
   customer's mobile, which fires the SMS auto-reply. Only the mobile is
   passed as a contact field \u2014 no email \u2014 so Coax can only reply by text.
   The API checks the calling site's origin, so this only works from the TWB domain. */
const COAX = {
endpoint:    'https://api.getcoax.com/api/v2/message/enquiry/widget',
key:         'lZRjSDM',
identifier:  '534ae9',
location_id: 'fe6ddbff-1d2e-4b3c-8438-48d22c760aa2',
timeoutMs:   10000
};

/* ---------- Trading hours (Townsville time, no daylight saving) ----------
   Drives the "When" labels: business-hours jobs booked while we're closed are
   shown as next business day; after-hours jobs are ASAP. 0 = Sunday. */
const HOURS = {1:[8,16.5],2:[8,16.5],3:[8,16.5],4:[8,16.5],5:[8,16.5],6:[9,13]};
const DAYN  = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
function nowBris(){ try{ return new Date(new Date().toLocaleString('en-US',{timeZone:'Australia/Brisbane'})); }catch(e){ return new Date(); } }
function fmtH(h){ var hh=Math.floor(h),mm=Math.round((h-hh)*60),ap=hh>=12?'pm':'am'; hh=hh%12||12; return hh+(mm?':'+(mm<10?'0':'')+mm:'')+ap; }
function tradingNow(){
var n=nowBris(), d=n.getDay(), t=n.getHours()+n.getMinutes()/60, today=HOURS[d];
var open = !!(today && t>=today[0] && t<today[1]);
var next = null;
if(!open){
if(today && t<today[0]) next={ day:'today', dayName:DAYN[d], at:fmtH(today[0]) };
else for(var i=1;i<=7;i++){ var nd=(d+i)%7; if(HOURS[nd]){ next={ day:(i===1?'tomorrow':DAYN[nd]), dayName:DAYN[nd], at:fmtH(HOURS[nd][0]) }; break; } }
}
return { open:open, next:next, closesAt: open?fmtH(today[1]):null };
}
/* Short and long descriptions of the chosen timing, for the UI and the Coax message */
function timingInfo(){
var tn = tradingNow();
if(state.timing==='after'){
return { key:'after', short:'After hours \u2014 ASAP', label:'After hours / Sunday \u2014 ASAP', open:tn.open, next:tn.next };
}
if(tn.open){
return { key:'hours', short:'Business hours \u2014 today', label:'Business hours (Mon\u2013Sat) \u2014 today', open:true, next:null };
}
var when = tn.next ? (tn.next.day==='today' ? 'today from '+tn.next.at : (tn.next.day==='tomorrow' ? 'tomorrow ('+tn.next.dayName.slice(0,3)+') from '+tn.next.at : tn.next.dayName.slice(0,3)+' from '+tn.next.at)) : 'next business day';
return { key:'hours', short:'Business hours \u2014 next business day ('+when+')', label:'Business hours \u2014 next business day, '+when, open:false, next:tn.next, when:when };
}
function refreshWhenLabels(){
var sel=$('when'); if(!sel) return;
var tn=tradingNow();
var oH=sel.querySelector('option[value="hours"]'), oA=sel.querySelector('option[value="after"]');
if(oH) oH.textContent = tn.open ? 'Business hours (Mon\u2013Sat) \u2014 today' : 'Business hours \u2014 next business day';
if(oA) oA.textContent = 'After hours / Sunday \u2014 ASAP';
}

function auMobile(v){
const d = (v||'').replace(/[^\d+]/g,'');
if (d.startsWith('+61')) return d;
if (d.startsWith('61') && d.length >= 11) return '+' + d;
if (d.startsWith('0'))  return '+61' + d.slice(1);
if (d.length === 9)     return '+61' + d;
return d;
}
function validMobile(v){ return /^\+61[45]\d{8}$/.test(auMobile(v)); }
function newRef(){ return 'TWB-' + Math.random().toString(36).slice(2,7).toUpperCase(); }
const $ = id => document.getElementById(id);
const norm = s => (s||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
const state = { row:null, xrow:null, lane:'instore', tier:null, timing:'hours' };

/* ---------- Coax send (shared by the quote form and the can't-find form) ---------- */
function postEnquiry(name, mobile, message, meta){
if(!COAX.endpoint) return Promise.resolve(false);
var ctrl = new AbortController();
var timer = setTimeout(function(){ctrl.abort();}, COAX.timeoutMs);
var payload = {
key:          COAX.key,
identifier:   COAX.identifier,
location_id:  COAX.location_id,
name:         name,
phone_number: mobile,
phone:        mobile,
message:      message,
timezone:     'Australia/Brisbane',
meta:         meta || {}
};
return fetch(COAX.endpoint, {
method:'POST',
headers:{'Content-Type':'application/json'},
body: JSON.stringify(payload),
signal: ctrl.signal
})
.then(function(res){ clearTimeout(timer); return res.json().catch(function(){return {};}).then(function(j){ return res.ok && j && j.success !== false; }); })
.catch(function(e){ clearTimeout(timer); console.error('Coax handoff failed:', e); return false; });
}

/* ---------- Can't find your vehicle form ---------- */
(function(){
var open=$('stuckOpen'), form=$('stuckForm'), send=$('stuckSend'), done=$('stuckDone');
if(!open||!form||!send) return;
open.addEventListener('click', function(){
form.classList.remove('hidden'); open.classList.add('hidden');
var n=$('sn'); if(n) n.focus();
form.scrollIntoView({behavior:'smooth',block:'center'});
});
send.addEventListener('click', function(){
var name=($('sn').value||'').trim(), mob=$('sp').value, veh=($('sv').value||'').trim(), note=($('sm').value||'').trim();
if(!name){ alert('We need a name so we know who we\'re texting.'); $('sn').focus(); return; }
if(!validMobile(mob)){ alert('That mobile doesn\'t look right \u2014 it needs to be a mobile like 0400 000 000 so we can text you.'); $('sp').focus(); return; }
if(!veh){ alert('Tell us what you drive \u2014 make, model and year, or just the rego.'); $('sv').focus(); return; }
var ref=newRef();
var lines=['BATTERY FINDER \u2014 VEHICLE NOT LISTED \u2014 '+ref, 'Vehicle / rego: '+veh];
if(note) lines.push('Notes: '+note);
send.disabled=true; send.textContent='Sending\u2026';
postEnquiry(name, auMobile(mob), lines.join('\n'), {source:'twb-battery-finder-stuck', ref:ref, vehicle:veh, page:location.pathname})
.then(function(ok){
send.disabled=false; send.textContent='Text me a quote';
if(done){
done.innerHTML = ok
? '<b>Got it \u2014 reference '+ref+'.</b> A text is on its way to '+auMobile(mob)+' now, and we\'ll follow up with the right battery and a price. Just reply to that text.'
: '<b>We couldn\'t send that automatically.</b> Call or text us on <a href="tel:0459364303">0459 364 303</a> with your vehicle details and quote '+ref+'.';
done.classList.remove('hidden');
}
if(ok){ form.querySelectorAll('input,textarea,button').forEach(function(el){ el.style.display='none'; }); form.querySelectorAll('label').forEach(function(el){ el.style.display='none'; }); }
});
});
})();

if(!$('make')) return;
$('make').innerHTML='<option value="">Select make</option>'+Object.keys(DATA.makes).map(m=>'<option>'+m+'</option>').join('');
let models=[];
let sugIdx=-1;
const sug=$('sug');
sug.style.maxHeight='340px';
/* Clicking or dragging the list's scrollbar must not blur the input (which closes the list) */
sug.addEventListener('mousedown', e=>{ if(!e.target.closest('div[data-m]')) e.preventDefault(); });
function sugItems(){ return sug.querySelectorAll('div[data-m]'); }
function sugHighlight(i){
const items=sugItems(); if(!items.length){ sugIdx=-1; return; }
sugIdx = (i+items.length)%items.length;
items.forEach((el,k)=>el.classList.toggle('is-active', k===sugIdx));
const el=items[sugIdx]; if(el && el.scrollIntoView) el.scrollIntoView({block:'nearest'});
}
function sugPick(m){ $('model').value=m; sug.classList.add('hidden'); sugIdx=-1; pickVariant(); ready(); }
$('make').addEventListener('change',()=>{
models=Object.keys(DATA.makes[$('make').value]||{}).sort();
$('model').value=''; $('model').disabled=!models.length;
$('variantWrap').classList.add('hidden'); sug.classList.add('hidden'); ready();
if(models.length) $('model').focus();
});
$('model').addEventListener('input',()=>{
const q=$('model').value.trim().toLowerCase();
sugIdx=-1;
if(!q){sug.classList.add('hidden');ready();return;}
const hits=models.filter(m=>m.toLowerCase().includes(q)).slice(0,60);
sug.innerHTML=hits.length?hits.map(m=>'<div data-m="'+m.replace(/"/g,'&quot;')+'">'+m+'</div>').join('')
:'<div class="none">No match \u2014 try fewer words, or use the form below to text us your details.</div>';
sug.classList.remove('hidden');
sug.querySelectorAll('div[data-m]').forEach(el=>el.addEventListener('mousedown',e=>{ e.preventDefault(); sugPick(el.dataset.m); }));
ready();
});
$('model').addEventListener('keydown',e=>{
if(sug.classList.contains('hidden')) return;
if(e.key==='ArrowDown'){ e.preventDefault(); sugHighlight(sugIdx+1); }
else if(e.key==='ArrowUp'){ e.preventDefault(); sugHighlight(sugIdx-1); }
else if(e.key==='Enter'){ const items=sugItems(); if(sugIdx>=0&&items[sugIdx]){ e.preventDefault(); sugPick(items[sugIdx].dataset.m); } else if(items.length===1){ e.preventDefault(); sugPick(items[0].dataset.m); } }
else if(e.key==='Escape'){ sug.classList.add('hidden'); }
});
$('model').addEventListener('blur',()=>setTimeout(()=>sug.classList.add('hidden'),150));
function pickVariant(){
const rows=(DATA.makes[$('make').value]||{})[$('model').value]||[];
if(rows.length>1){
$('variant').innerHTML=rows.map((r,i)=>{
const b=[r[1],r[0]].filter(Boolean).join('  \u00b7  ');
return '<option value="'+i+'">'+(b||('Option '+(i+1)))+'</option>';
}).join('');
$('variantWrap').classList.remove('hidden');
} else $('variantWrap').classList.add('hidden');
}
function ready(){
$('go').disabled = !($('make').value && (DATA.makes[$('make').value]||{})[$('model').value]);
}
$('go').addEventListener('click', goVehicle);

function goVehicle(){
const rows=(DATA.makes[$('make').value]||{})[$('model').value]||[];
if(!rows.length) return;
const i=$('variantWrap').classList.contains('hidden')?0:+$('variant').value;
const r=rows[i];
state.row=r;
state.xrow=xrowFor(r[2]);
$('vn').textContent=$('make').value+' '+$('model').value;
$('vm').textContent=[r[1],r[0]].filter(Boolean).join('  \u00b7  ');
show();
}
function xrowFor(p){ const ids=DATA.xindex[norm(p)]; return ids?DATA.xrows[ids[0]]:null; }
function show(){
const r=state.row, ss=r[6];
const none=!r[3]&&!r[4]&&!r[5];
$('nostock').classList.toggle('hidden', !none);
const evhy = /hybrid|electric|PHEV|Prius|IONIQ/i.test($('vn').textContent);
$('nsTitle').textContent = evhy ? 'Let\'s confirm this one over the phone'
: 'We don\'t keep this one on the shelf';
$('nsBody').textContent = evhy
? 'The 12V battery in hybrids and EVs varies between builds, and the wrong one is an expensive mistake. Give us a call with your rego or VIN and we\'ll confirm exactly what yours takes.'
: 'Your vehicle takes a size we don\'t stock in any of our ranges \u2014 but we can almost always get it, often same day. Give us a call and we\'ll sort it out.';
$('tiers').classList.toggle('hidden', none);
$('warn').classList.toggle('hidden',!(ss||none));
const needsCheck = r.length>7 && r[7];
$('verify').classList.toggle('hidden', !needsCheck);
if(needsCheck) $('verify').innerHTML =
'<b>Two battery sizes were fitted to this model.</b> Pick the one that matches yours if you know it \u2014 '+
'otherwise choose either and we\'ll confirm before we come out. If you can, reply to our text with a '+
'photo of the label on your current battery and we\'ll check it against the one we\'re bringing.';
if(none) $('warn').classList.add('hidden');
else if(ss) $('warn').innerHTML='<b>This is a stop-start vehicle.</b> It needs an AGM or EFB battery. A standard flooded battery will fail early and can throw charging faults, so the Silver option is shown but not offered.';
state.tier = r[4]&&ss ? 'gold' : (r[3]&&!ss ? 'silver' : (r[5]?'amaron':null));
if(none){ $('booking').classList.add('on'); }
$('results').classList.remove('hidden'); $('panel').classList.add('hidden');
$('reset').classList.remove('hidden');
if($('howto')) $('howto').classList.add('hidden');
var w=document.querySelector('.twb-finder-root .wrap'); if(w) w.classList.add('on');
refreshWhenLabels();
renderLanes(); renderTiers(); renderXref(); syncAddress();
$('results').scrollIntoView({behavior:'smooth',block:'start'});
}
$('change').addEventListener('click',reset); $('reset').addEventListener('click',reset);
function reset(){
state.row=null;state.xrow=null;
$('results').classList.add('hidden'); $('panel').classList.remove('hidden');
$('reset').classList.add('hidden');
if($('howto')) $('howto').classList.remove('hidden');
var w2=document.querySelector('.twb-finder-root .wrap'); if(w2) w2.classList.remove('on');
$('booking').classList.remove('on'); $('sent').classList.remove('on');
$('make').value='';$('model').value='';$('model').disabled=true;
$('variantWrap').classList.add('hidden'); ready(); window.scrollTo({top:0,behavior:'smooth'});
}
function lane(){ return CONFIG.lanes.find(l=>l.key===state.lane) || CONFIG.lanes[0]; }
function fee(){
const l = lane();
const v = l.fee[state.timing];
return v === undefined ? null : v;
}
function laneAvailable(l){ return l.fee[state.timing] !== null; }
function renderLanes(){
$('laneOpts').innerHTML = CONFIG.lanes.map(l=>{
const ok = laneAvailable(l);
const f  = l.fee[state.timing];
const price = !ok ? '\u2014' : (f===0 ? 'Free' : '+'+CONFIG.money(f));
return '<button class="lopt" data-lane="'+l.key+'" aria-pressed="'+(state.lane===l.key)+'"'+
(ok?'':' disabled')+'>'+
'<span class="fee">'+price+'</span>'+
'<strong>'+l.label+'</strong><span>'+l.blurb+'</span>'+
(ok?'':'<span class="why">'+(l.key==='instore'
? 'We\'re closed \u2014 we can still come to you'
: 'Business hours only \u2014 we can still come to you')+'</span>')+
'</button>';
}).join('');
$('laneOpts').querySelectorAll('.lopt:not([disabled])').forEach(b=>
b.addEventListener('click',()=>{
state.lane=b.dataset.lane;
renderLanes(); renderTiers(); syncAddress();
}));
const l = lane();
const ti = timingInfo();
let z;
if(ti.key==='after'){
z = '<b>ASAP</b> \u2014 we\'re on call now and usually there within the hour anywhere in Townsville. '+CONFIG.money(CONFIG.lanes[2].fee.after)+' callout; the shop is closed and there\'s no delivery run after hours.';
} else if(ti.open){
z = l.key==='delivery' ? '<b>Same day</b> to your door if you order before we close.'
: (l.key==='mobile' ? '<b>Usually within the hour</b> anywhere in Townsville during business hours.'
: 'Pop in any time we\'re open \u2014 fitting is free with the battery.');
} else {
const nudge = ' Need it sooner? Choose <b>After hours \u2014 ASAP</b> above and we\'ll come out now ('+CONFIG.money(CONFIG.lanes[2].fee.after)+' callout).';
z = '<b>Next business day</b> \u2014 we\'re closed right now, so this will be '+
(l.key==='delivery' ? 'delivered ' : (l.key==='mobile' ? 'fitted at your place ' : 'ready for you in store '))+
'<b>'+ti.when+'</b>.'+nudge;
}
$('zone').innerHTML = z;
}
function syncAddress(){
const need = lane().address;
$('addrWrap').style.display = need ? '' : 'none';
$('addrLabel').textContent = state.lane==='delivery' ? 'Delivery address' : 'Address for the call-out';
}
$('when').addEventListener('change',()=>{
state.timing=$('when').value;
if(!laneAvailable(lane())){
const open = CONFIG.lanes.find(laneAvailable);
if(open) state.lane = open.key;
}
renderLanes(); renderTiers(); syncAddress();
});
const TIERS=[
{key:'silver',slot:3,label:'Good',brand:'TWB Silver Series'},
{key:'gold',  slot:4,label:'Better',brand:'TWB Gold Series'},
{key:'amaron',slot:5,label:'Best',brand:'Amaron'}
];
function tierList(){
const r=state.row, ss=r[6];
return TIERS.map(t=>{
const code=r[t.slot];
const p=code?DATA.prod[code]:null;
const unsuitable = t.key==='silver' && ss && !!p;
return Object.assign({}, t, { code:code, p:p, price: p?p.p:null, unsuitable:unsuitable });
});
}
function renderTiers(){
if(!state.row) return;
const f=fee();
$('tiers').innerHTML=tierList().map(t=>{
if(!t.p){
const confirmed = (DATA.conf[state.row[2]]||[]).indexOf(t.key)>-1;
const why = confirmed
? 'We don\'t stock this size in the ' + t.brand.replace('TWB ','') +
' range \u2014 the other options shown are the right fit for your vehicle.'
: 'Nothing in the ' + t.brand.replace('TWB ','') + ' range fits this one. '+
'Send it through and we\'ll check what we can get.';
return '<div class="tier empty"><div class="th"><div class="tl">'+t.label+'</div>'+
'<div class="tb">'+t.brand+'</div><div class="tn" style="color:#8a8a90">Not available for this vehicle</div></div>'+
'<div class="emptymsg">'+why+'</div></div>';
}
const total=(t.price==null||f===null)?null:t.price+f;
if(t.unsuitable){
return '<div class="tier unsuit"><div class="flag warnflag">Not suitable</div>'+
'<div class="th"><div class="tl">'+t.label+'</div><div class="tb">'+t.brand+'</div>'+
'<div class="tn" style="color:#8a8a90">'+t.p.n.replace(/ Car Battery$/,'')+'</div>'+
'<div class="td">Standard flooded \u2014 SKU '+(t.p.s||'\u2014')+'</div></div>'+
'<div class="emptymsg">Your vehicle is stop-start. A flooded battery isn\'t a cheaper choice here, it\'s the wrong one \u2014 it will fail early and the warranty won\'t cover it.</div></div>';
}
return '<div class="tier'+(t.key===state.tier?' pick':'')+'" data-t="'+t.key+'">'+
(t.key===state.tier?'<div class="flag">Recommended</div>':'')+
'<div class="th"><div class="tl">'+t.label+'</div><div class="tb">'+t.brand+'</div>'+
'<div class="tn">'+t.p.n.replace(/ Car Battery$/,'')+'</div>'+
'<div class="td">SKU '+(t.p.s||'\u2014')+(t.p.a?'':'  \u00b7  not published yet')+'</div></div>'+
'<div class="tspecs">'+
'<div class="sp"><b>'+(t.p.ss?'AGM / EFB':'Flooded')+'</b><span>Type</span></div>'+
'<div class="sp"><b>'+(t.p.p?CONFIG.money(t.p.p):'\u2014')+'</b><span>Battery only</span></div></div>'+
'<div class="tp">'+
'<div class="pl"><span>Battery</span><span>'+(t.price==null?'Call':CONFIG.money(t.price))+'</span></div>'+
'<div class="pl"><span>'+lane().feeLabel+'</span><span>'+
(f===null?'Call us':(f===0?'Free':CONFIG.money(f)))+'</span></div>'+
'<div class="pt"><span>Total inc GST</span><b>'+(total==null?'\u2014':CONFIG.money(total))+'</b></div>'+
'<div class="stock"><span class="dot"></span>Usually in stock</div>'+
'<button class="btn">Choose this one</button></div></div>';
}).join('');
$('tiers').querySelectorAll('.tier .btn').forEach(b=>b.addEventListener('click',e=>{
state.tier=e.target.closest('.tier').dataset.t; renderTiers(); openBooking();
}));
}
function renderXref(){
const rec=state.xrow;
if(!rec){$('xrefBox').classList.add('hidden');return;}
const rows=Object.keys(DATA.labels).filter(b=>rec[b]).map(b=>'<tr><td>'+DATA.labels[b]+'</td><td>'+rec[b]+'</td></tr>').join('');
$('xrefTable').innerHTML=rows;
$('xrefBox').classList.toggle('hidden',!rows);
}
function openBooking(){
const t=tierList().find(x=>x.key===state.tier);
const ti=timingInfo();
if(!t||!t.p){ $('summary').innerHTML='<div class="row"><span>Vehicle</span><b>'+$('vn').textContent+'</b></div>'+
'<div class="row"><span>Battery</span><b>We\'ll source it and quote you</b></div>'+
'<div class="row"><span>When</span><b>'+ti.short+'</b></div>';
$('booking').classList.add('on'); return; }
const f=fee(), total=(t.price==null||f===null)?null:t.price+f;
$('summary').innerHTML=
'<div class="row"><span>Vehicle</span><b>'+$('vn').textContent+'</b></div>'+
'<div class="row"><span>Battery</span><b>'+t.p.n+'</b></div>'+
'<div class="row"><span>Service</span><b>'+lane().label+'</b></div>'+
'<div class="row"><span>When</span><b>'+ti.short+'</b></div>'+
'<div class="row"><span>Battery</span><span>'+(t.price==null?'On enquiry':CONFIG.money(t.price))+'</span></div>'+
'<div class="row"><span>'+lane().feeLabel+'</span><span>'+
(f===null?'To be quoted':(f===0?'Free':CONFIG.money(f)))+'</span></div>'+
'<div class="row total"><span>Total inc GST</span><span>'+(total==null?'On enquiry':CONFIG.money(total))+'</span></div>';
$('booking').classList.add('on'); $('sent').classList.remove('on');
syncAddress();
$('booking').scrollIntoView({behavior:'smooth',block:'center'});
}
$('send').addEventListener('click', function(){
if(!$('cn').value.trim()){ alert('We need a name so we know who we\'re texting.'); return; }
if(!validMobile($('cp').value)){
alert('That mobile doesn\'t look right. We text the quote straight back, so it needs to be a mobile \u2014 like 0400 000 000.');
$('cp').focus(); return;
}
const t = tierList().find(x=>x.key===state.tier);
const f = fee();
const p = t ? t.price : null;
const total = (p==null||f===null) ? null : p+f;
const ref = newRef();
const ti = timingInfo();
const booking = {
ref: ref,
name:    $('cn').value.trim(),
mobile:  auMobile($('cp').value),
email:   $('ce').value.trim(),
address: lane().address ? $('ca').value.trim() : '',
vehicle: $('vn').textContent + (state.row[6] ? '  [STOP-START \u2014 AGM/EFB required]' : ''),
battery: t && t.p ? t.p.n.replace(/ Car Battery$/,'') : 'to be quoted',
tier:    t ? t.label : '',
service: lane().label + (f ? ' (' + CONFIG.money(f) + ')' : ' (no charge)'),
timing:  ti.short,
priority: ti.key==='after' ? 'ASAP' : (ti.open ? 'Today' : 'Next business day'),
price:   p==null ? '' : CONFIG.money(p),
total:   total==null ? 'on enquiry' : CONFIG.money(total),
notes:   $('cnote').value.trim(),
fitref:  state.row[2] || '',
verify:  (state.row.length>7 && state.row[7])
? 'YES \u2014 two sizes fitted to this model, confirm before loading' : ''
};
const btn = $('send');
btn.disabled = true; btn.textContent = 'Sending\u2026';
postEnquiry(booking.name, booking.mobile, coaxMessage(booking), {
source:'twb-battery-finder', ref:booking.ref, vehicle:booking.vehicle, battery:booking.battery, tier:booking.tier,
service:booking.service, timing:booking.timing, priority:booking.priority, total:booking.total, fitment_ref:booking.fitref, verify_fitment:booking.verify, page:location.pathname
}).then(function(sent){
btn.disabled = false; btn.textContent = 'Text me this quote';
$('ref').textContent = ref;
$('sentMsg').innerHTML = sent
? 'We\'ve got it. A text is on its way to <b>' + booking.mobile + '</b> now, and we\'ll follow up with your quote shortly \u2014 just reply to that text to lock in a time.'
: 'We couldn\'t get that through automatically. Call us on <b>0459 364 303</b> and quote <b>' + ref + '</b>, or text the details below to the same number.';
$('payloadOut').textContent = Object.keys(booking)
.filter(function(k){return booking[k]!=='';})
.map(function(k){return k.toUpperCase()+'  '+booking[k];}).join('\n');
$('booking').classList.remove('on'); $('sent').classList.add('on');
$('sent').scrollIntoView({behavior:'smooth',block:'center'});
});
});
/* The message the team sees in the Coax thread. Everything goes in here,
   including the email, because it's the one field guaranteed to show. */
function coaxMessage(b){
var head = b.priority==='ASAP' ? 'ASAP AFTER-HOURS CALLOUT \u2014 ' : (b.priority==='Next business day' ? 'NEXT BUSINESS DAY \u2014 ' : '');
var lines = [
head + 'BATTERY FINDER QUOTE \u2014 ' + b.ref,
'Vehicle: ' + b.vehicle,
'Battery: ' + b.battery + (b.tier ? ' (' + b.tier + ')' : ''),
'Service: ' + b.service,
'When: ' + b.timing,
'Battery price: ' + (b.price || 'on enquiry'),
'Total inc GST: ' + b.total
];
if (b.address) lines.push('Address: ' + b.address);
if (b.email)   lines.push('Email: ' + b.email);
if (b.notes)   lines.push('Notes: ' + b.notes);
if (b.fitref)  lines.push('Fitment ref: ' + b.fitref);
if (b.verify)  lines.push('VERIFY FITMENT: ' + b.verify);
return lines.join('\n');
}
refreshWhenLabels();
})();
